<template>
    <div class="app-container">
        <div class="filter-head">
            <div class="filter-item">
                <el-input v-model="listQuery.admin_name" placeholder="账号" />
            </div>
            <div class="filter-item">
                <el-input v-model="listQuery.content" placeholder="内容" />
            </div>
            <div class="filter-item">
                <el-input v-model="listQuery.parameter" placeholder="请求参数" />
            </div>
            <div class="filter-item">
                <el-input v-model="listQuery.IP" placeholder="IP地址" />
            </div>
            <div class="filter-item">
                <el-select v-model="listQuery.mode" placeholder="方式" clearable>
                    <el-option label="GET" :value="2" />
                    <el-option label="POST" :value="1" />
                </el-select>
            </div>
            <div class="filter-item">
                <el-date-picker v-model="filteDateRange" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm" @change="onChangeDateRange">
                </el-date-picker>
            </div>
            <div class="filter-item">
                <el-button type="primary" @click="handleFilter">搜索</el-button>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData" v-loading="tableLoading" border fit highlight-current-row height="65vh">
                <el-table-column type="index" label="序号" width="100" align="center" />
                <el-table-column prop="admin_name" label="操作账号" width="160" align="center" />
                <el-table-column prop="route" label="操作对象" min-width="100" align="center" />
                <el-table-column prop="content" label="操作内容" min-width="100" align="center" />
                <el-table-column prop="result" label="操作结果" min-width="100" align="center" />
                <el-table-column label="请求参数" min-width="100" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.parameter }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="mode" label="方式" width="100" align="center" />
                <el-table-column prop="ip" label="IP地址" width="132" align="center" />
                <el-table-column prop="created_at" label="操作时间" width="166" align="center" />
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    :total="total" background layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
    </div>
</template>

<script>
// 系统日志
import { systemLog } from "@/api/system"

export default {
    data: () => ({
        tableData: [],
        tableLoading: false,
        total: null,
        listQuery: {
            page: 1,
            limit: 10,
            admin_name: '',
            content: '',
            parameter: '',
            IP: '',
            start_at: '',
            end_at: ''
        },
        filteDateRange: null
    }),
    methods: {
        async getList() {
            this.tableLoading = true;
            this.tableData = []
            const { data } = await systemLog(this.listQuery)
            this.tableData = data.data;
            this.total = data.total;
            this.tableLoading = false;
        },
        handleFilter() {
            this.listQuery.page = 1
            this.getList()
        },
        // 分页操作
        handleSizeChange(limit) {
            this.listQuery.limit = limit
            this.getList()
        },
        handleCurrentChange(page) {
            this.listQuery.page = page
            this.getList()
        },
        onChangeDateRange(t) {
            if (t === null) {
                this.listQuery.start_at = null
                this.listQuery.end_at = null
                return
            }
            this.listQuery.start_at = t[0]
            this.listQuery.end_at = t[1]
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
.filter-head {
    display: flex;
    align-items: center;
    margin: 0 -5px;

    .filter-item {
        margin: 0 5px;
    }
}

.table {
    margin-top: 10px;
}
</style>